export function addToClipboard(text: string, html: string) {
    const clipboardItem = new ClipboardItem({
        'text/plain': new Blob([text], { type: 'text/plain' }),
        'text/html': new Blob([html], { type: 'text/html' }),
    });

    navigator.clipboard.write([clipboardItem]);
}
